const FETCH_VOICES_SUCCESS = 'app/selectVoice/FETCH_VOICES_SUCCESS'
const SET_DRILLDOWN_LEVEL = 'app/selectVoice/SET_DRILLDOWN_LEVEL'
const SET_USER_ACTIVE_IN_EDITOR = 'app/selectVoice/SET_USER_ACTIVE_IN_EDITOR'
const SET_IS_CURSOR_AT_START = 'app/selectVoice/SET_IS_CURSOR_AT_START'
const SET_FULLSCREEN = 'app/selectVoice/SET_FULLSCREEN'

export { FETCH_VOICES_SUCCESS, SET_DRILLDOWN_LEVEL, SET_USER_ACTIVE_IN_EDITOR, SET_IS_CURSOR_AT_START, SET_FULLSCREEN }
